import ProductCard from "./ProductCard";
customElements.define('product-card', ProductCard)

const productCards = document.querySelectorAll<ProductCard>('product-card')